import { render, staticRenderFns } from "./classification.vue?vue&type=template&id=5336aab2&scoped=true&lang=pug"
import script from "./classification.vue?vue&type=script&lang=js"
export * from "./classification.vue?vue&type=script&lang=js"
import style0 from "./classification.vue?vue&type=style&index=0&id=5336aab2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5336aab2",
  null
  
)

export default component.exports